import ConversationsList from './ConversationsList';

export default ConversationsList;
